/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useFiltersList } from '@api/hooks';

import SearchableEntitySelect from '../SearchableEntitySelect';

const FilterSelect = ({ placeholder = 'Type the name of filter...', ...props }) => (
  <SearchableEntitySelect
    placeholder={placeholder}
    useList={useFiltersList}
    formatLabel={({ title }) => title}
    {...props}
  />
);

export default FilterSelect;
